import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import { Modal, ModalHeader, ModalBody, ModalFooter } from '@this/shared/ui/feedbacks/modal';
import { Button } from '@this/shared/ui/inputs/button';
import type { AITTheme } from '@this/shared/ui/theme';

interface Props {
  showBusinessEkinetModal: boolean;
  tripId: number | null;
  handleSubmitBusinessEkinet: (id: number | null, e: React.MouseEvent<HTMLElement>) => void;
  handleCancelBusinessEkinet: () => void;
  businessEkinetError: string | null;
}

function getStyles(theme: AITTheme) {
  return {
    message: {
      textAlign: 'center' as const,
      fontSize: '18px',
      fontWeight: 500,
      marginTop: '20px',
      marginBottom: '10px'
    },
    hint: {
      textAlign: 'center' as const,
      marginBottom: '10px'
    },
    error: {
      color: theme.tokens.colors.danger.primary,
      margin: '20px',
      textAlign: 'center' as const
    },
    buttons: {
      display: 'flex',
      justifyContent: 'center',
      gap: '20px'
    }
  };
}

const BusinessEkinetModal: React.FC<Props> = ({
  showBusinessEkinetModal,
  tripId,
  handleSubmitBusinessEkinet,
  handleCancelBusinessEkinet,
  businessEkinetError
}) => {
  const theme = useTheme<AITTheme>();
  const styles = getStyles(theme);

  return (
    <Modal open={showBusinessEkinetModal} onClose={() => handleCancelBusinessEkinet()} size="large">
      <ModalHeader>ビジネスえきねっと予約</ModalHeader>
      <ModalBody>
        <p style={styles.message}>ここから先はAIトラベルのWebサイトではありません</p>
        <p style={styles.hint}>JR東日本のWebサイトに移動します</p>
        {businessEkinetError && <p style={styles.error}>{businessEkinetError}</p>}
      </ModalBody>
      <ModalFooter style={styles.buttons}>
        <Button
          color="primary"
          disabled={!!businessEkinetError}
          onClick={e => handleSubmitBusinessEkinet(tripId, e)}
        >
          続ける
        </Button>
        <Button color="sub" onClick={handleCancelBusinessEkinet}>
          キャンセル
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default BusinessEkinetModal;
